import Vue from 'vue'
// import store from '@/store'
import { hasPermission } from '@/permission/index.js'

Vue.directive('permission', {
  inserted(el, bindling) {
    //bindling.value为指令的绑定值
    let perVal = bindling.value
    if (perVal) {
      // //假设某用户对某模块只有添加和删除的权限
      // //这个权限信息(即pers)应该是不同用户登录时从后台拿到的对应的信息
      // let pers = store.getters.permissionCodeList
      // //hasPer为true为有权限
      // //hasPer为false为无权限
      // let hasPer = pers.some((item) => {
      //   return item == perVal
      // })
      //没有权限就先隐藏此元素吧
      if (!hasPermission(perVal)) {
        el.style.display = 'none'
      }
    }
  },
})
